<script setup lang="ts">
import type { Project } from '../types';
import TmArchive from './TmArchive/TmArchive.vue';

type Props = {
  projects: Project[];
};

defineProps<Props>();
</script>

<template>
  <TmArchive :projects="projects" />
</template>
